import { render, staticRenderFns } from "./PalletSizesTile.vue?vue&type=template&id=5772f4bc&scoped=true&"
import script from "./PalletSizesTile.vue?vue&type=script&lang=ts&"
export * from "./PalletSizesTile.vue?vue&type=script&lang=ts&"
import style0 from "./PalletSizesTile.vue?vue&type=style&index=0&id=5772f4bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5772f4bc",
  null
  
)

export default component.exports